import { Grid, Typography } from "@mui/material";
import { useSingleObjetivo } from "../../../../context/SuperAdmin/OASContexts/SingleObjetivoContext";

const SingleObjDescription = () => {
  const { objetivo } = useSingleObjetivo();
  return (
    <Grid
      container
      sx={{
        padding: 4,
        backgroundColor: "#EEF3F6",
        display: "grid",
        gridTemplateColumns: "repeat(1, 1fr)",
        width: 1,
        gap: 2,
      }}
    >
      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Contenido:
        </Typography>
        <Typography fontSize={18}>{objetivo?.nombre}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Código:
        </Typography>
        <Typography fontSize={18}>{objetivo?.codigo}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Nivel:
        </Typography>
        <Typography fontSize={18}>{objetivo?.nivel}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Asignatura:
        </Typography>
        <Typography fontSize={18}>{objetivo?.asignatura}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Tipo:
        </Typography>
        <Typography fontSize={18}>{objetivo?.tipo}</Typography>
      </Grid>

      <Grid item display={"flex"} gap={2}>
        <Typography fontSize={18} sx={{ fontWeight: 700 }}>
          Estado:
        </Typography>
        <Typography fontSize={18}>{objetivo?.estado}</Typography>
      </Grid>
    </Grid>
  );
};

export default SingleObjDescription;
